import axios from "axios";

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    // Do something before request is sent
    window.Vue.$Progress.start();
    // window.Vue.$Gears.hide()
    // window.Vue.$Gears.show()
    return config;
  },
  err => {
    // Do something with request error
    window.Vue.$Progress.fail();
    // window.Vue.$Gears.hide()
    return Promise.reject(err);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  res => {
    // Do something with response data
    window.Vue.$Progress.finish();
    // window.Vue.$Gears.hide()
    return res;
  },
  err => {
    // Do something with response error
    window.Vue.$Progress.fail();
    // window.Vue.$Gears.hide()
    if (!err.response) return Promise.reject(err);
    switch (err.response.status) {
      case 401:
        window.location = `/sign-in?redirectUrl=${window.location.pathname}`;
        break;
      case 403:
        window.location = "/403";
        break;
      case 404:
        window.location = "/404";
        break;
    }
    return Promise.reject(err);
  }
);

export default axios;
